import React from 'react';

import {
  TextBlockContainer,
  TextBlockText,
  TextBlockSection,
  TextBlocksContainer,
  TextBlockTitle,
  TextBlockCTAsContainer,
} from 'components/TextBlock/TextBlock.styles';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { COLORS3 } from '@zola/zola-ui/src/styles/emotion';

import { noMarginTop } from './TextBlockSection2.styles';

type TextBlockSection2Props = {
  className?: string;
};

const TextBlockSection2 = ({ className }: TextBlockSection2Props): JSX.Element => (
  <div className={className}>
    <TextBlockSection>
      <TextBlocksContainer css={noMarginTop}>
        <TextBlockContainer>
          <TextBlockTitle>Book a coffee chat</TextBlockTitle>
          <TextBlockText color={COLORS3.BLACK_075}>
            Need some one-on-one advice? Book a 30-minute coffee chat with us! No question is too
            crazy (aka yes, we&apos;ll help you tell Uncle Arnie that his golf buddies aren&apos;t
            invited to your wedding).
          </TextBlockText>
          <TextBlockCTAsContainer>
            <ButtonV3
              component="a"
              href="https://forms.gle/hXtFegXV4292gYpTA"
              size="large"
              target="_black"
              rel="noopener noreferrer"
            >
              Book now
            </ButtonV3>
          </TextBlockCTAsContainer>
        </TextBlockContainer>
        <TextBlockContainer>
          <TextBlockTitle>You asked, we answered</TextBlockTitle>
          <TextBlockText color={COLORS3.BLACK_075}>
            Check out our expert advice page for wedding planning advice, tips and how-to&apos;s,
            inspired by questions from real couples.
          </TextBlockText>
          <TextBlockCTAsContainer>
            <ButtonV3 component="a" href="/expert-advice" size="large">
              Get answers
            </ButtonV3>
          </TextBlockCTAsContainer>
        </TextBlockContainer>
      </TextBlocksContainer>
    </TextBlockSection>
  </div>
);

export default TextBlockSection2;
